import React from "react";
import {
  Datagrid,
  DateField,
  List,
  ListActions,
  ReferenceField,
  ShowButton,
  SimpleList,
  TextField,
  Title,
  useStore,
  CreateButton,
  EditButton,
} from "react-admin";
import { Box, Paper, Typography, useMediaQuery } from "@mui/material";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import { administrationRequests } from "api/administrationApi";
import CustomFilter from "features/CustomFilter";
import useInternshipFilter from "features/filters/useInternshipFilter";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { formatDateOnlyBg } from "server/formatting/formatDateBg";
import { MOBILE_BREAKPOINT } from "utils/constants";

const STORE_KEY = "internshipIndividualCycleSchedule.filters";

const ListScheduleIndividualCycle = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const [filters, setFilters] = useStore(STORE_KEY, null);
  const internship = useInternshipFilter({ filters, withPlan: true });

  const handleSearch = selectedFilters => {
    setFilters(selectedFilters);
  };

  return (
    <>
      {!filters && <Title title={"Индивидуални циклични разписания"} />}
      <CustomFilter
        title="Избери филтри"
        cardWidth={isMobile ? "100%" : "700px"}
        filters={internship.fields}
        buttonLabel="Покажи"
        buttonDisabled={!internship.isComplete}
        buttonOnClick={() => handleSearch(internship.query)}
      />
      {!filters ? (
        <Paper sx={{ mt: 5 }}>
          <Box
            p={2}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography
              align="center"
              color="secondary"
            >
              Въведи филтри за индивидуално циклично разписание или създай ново
            </Typography>
            <SecuredComponent permission={permissions.canManageInternshipSchedules}>
              <CreateButton />
            </SecuredComponent>
          </Box>
        </Paper>
      ) : (
        <List
          exporter={false}
          title="Индивидуално циклично разписание"
          filter={filters}
          actions={
            <ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageInternshipSchedules)} />
          }
        >
          {isMobile ? (
            <SimpleList
              linkType={false}
              sx={settings.style.mobileList}
              primaryText={record => (
                <MobileListRow
                  fields={[
                    {
                      label: "Дисциплина",
                      value: (
                        <ReferenceField
                          source="disciplineId"
                          reference={administrationRequests.getDisciplinesSelect()}
                        >
                          <TextField source="name" />
                        </ReferenceField>
                      ),
                    },
                  ]}
                />
              )}
              secondaryText={record => (
                <MobileListRow
                  fields={[
                    { label: "От", value: formatDateOnlyBg(record?.fromDate) },
                    { label: "До", value: formatDateOnlyBg(record?.toDate) },
                  ]}
                />
              )}
              tertiaryText={() => (
                <>
                  <SecuredComponent permission={permissions.canManageInternshipSchedules}>
                    <EditButton label="" />
                  </SecuredComponent>
                  <SecuredComponent permission={permissions.canPreviewInternshipSchedules}>
                    <ShowButton label="" />
                  </SecuredComponent>
                </>
              )}
            />
          ) : (
            <Datagrid
              bulkActionButtons={false}
              rowClick={false}
              sx={{
                "& .RaDatagrid-headerCell": {
                  textAlign: "left",
                },
              }}
            >
              <ReferenceField
                source="disciplineId"
                reference={administrationRequests.getDisciplinesSelect()}
                label="Дисциплина"
                sortable={false}
              >
                <TextField source="name" />
              </ReferenceField>
              <DateField
                source="fromDate"
                label="От"
                sortable={false}
                locales="bg-BG"
              />
              <DateField
                source="toDate"
                label="До"
                sortable={false}
                locales="bg-BG"
              />
              <SecuredComponent permission={permissions.canManageInternshipSchedules}>
                <EditButton />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewInternshipSchedules}>
                <ShowButton />
              </SecuredComponent>
            </Datagrid>
          )}
        </List>
      )}
    </>
  );
};

export default ListScheduleIndividualCycle;
